import { Grid, Button, TextField, MenuItem, Checkbox, FormControlLabel, Typography, IconButton, Paper } from "@material-ui/core";
import * as React from "react";
import { ISubmitEvent } from "react-jsonschema-form";
import AddIcon from '@material-ui/icons/Add';
// import DeleteIcon from '@material-ui/icons/Delete';
import { Vehicle, Driver } from '../api/model';

interface PropsDriverForm {
    data?: Partial<Driver>;
    sendData: (e: ISubmitEvent<any>) => void;
    cancel: () => void;
    branches: Array<{ id: number; name: string }>;
}

interface StateDriverForm {
    // User data
    userName: string;
    userEmail: string;
    userPassword: string;

    // Driver data
    region: string;
    registryNumber: string;
    registryDate: string;
    phone: string;
    document: string;
    type: string;
    referenceId: number;
    notifyLocation: boolean;
    notifyLogout: boolean;
    recordLocation: boolean;
    outsourced: boolean;
    fixedPayment: number;
    paymentPerKm: number;

    // Vehicle data (single - existing)
    vehicleBrand: string;
    vehicleModel: string;
    vehicleType: string;
    vehicleYear: string;
    vehicleCapacidadVolumetrica: number;
    vehicleFixedPayment: number;
    vehiclePaymentPerKm: number;
    manager?: boolean;
    markAttendance?: boolean;

    // Additional vehicles array
    vehicles: Vehicle[];

    // Branch
    branchId: number;

    errors: {
        userName?: string;
        userEmail?: string;
        userPassword?: string;
        region?: string;
        registryNumber?: string;
        registryDate?: string;
        vehicleBrand?: string;
        vehicleType?: string;
        branchId?: string;
    };
}

class DriverForm extends React.Component<PropsDriverForm, StateDriverForm> {
    constructor(props: PropsDriverForm) {
        super(props);
        console.log("DriverForm props:", props);

        const data = props.data;
        // const isEdit = !!(data && data.id);

        this.state = {
            // User
            userName: data && data.user ? data.user.name : "",
            userEmail: data && data.user ? data.user.email : "",
            userPassword: "",

            // Driver
            region: data && data.region || "",
            registryNumber: data && data.registryNumber || "Sin registro",
            registryDate: data && data.registryDate ? (typeof data.registryDate === 'number' ? new Date(data.registryDate).toISOString().split('T')[0] : data.registryDate) : "",
            phone: (data as any) && (data as any).phone || "Sin número de teléfono",
            document: data && data.document || "Sin documento",
            type: "REMISION",
            referenceId: data && data.referenceId || 0,
            notifyLocation: (data && data.notifyLocation) ? true : false,
            notifyLogout: (data && data.notifyLogout) ? true : false,
            recordLocation: (data && data.recordLocation) ? true : false,
            outsourced: (data && data.outsourced) ? true : false,
            fixedPayment: data && data.fixedPayment || 0,
            paymentPerKm: data && data.paymentPerKm || 0,

            // Vehicle (existing single vehicle)
            vehicleBrand: data && data.vehicle && data.vehicle.brand || "",
            vehicleModel: data && data.vehicle && data.vehicle.model || "",
            vehicleType: data && data.vehicle && data.vehicle.type || "MOTORCYCLE",
            vehicleYear: data && data.vehicle && data.vehicle.year || "",
            vehicleCapacidadVolumetrica: data && data.vehicle && data.vehicle.capacidadVolumetrica || 0,
            vehicleFixedPayment: data && data.vehicle && data.vehicle.fixedPayment || 0,
            vehiclePaymentPerKm: data && data.vehicle && data.vehicle.paymentPerKm || 0,
            manager: data && data.manager || false,
            markAttendance: data && data.markAttendance || true,


            // Additional vehicles
            vehicles: data && data.vehicles || [],

            // Branch
            branchId: data && data.branch ? data.branch.id : 0,

            errors: {}
        };
    }

    validate(): boolean {
        const errors: any = {};
        const isEdit = !!(this.props.data && this.props.data.id);

        // User validation
        if (!this.state.userName.trim()) {
            errors.userName = "El nombre es obligatorio";
        }
        if (!this.state.userEmail.trim()) {
            errors.userEmail = "El correo electrónico es obligatorio";
        }
        if (!isEdit && (!this.state.userPassword || this.state.userPassword.length < 6)) {
            errors.userPassword = "La contraseña debe tener al menos 6 caracteres";
        }

        // Driver validation
        if (!this.state.region.trim()) {
            errors.region = "La región es obligatoria";
        }
        if (!this.state.registryNumber.trim()) {
            errors.registryNumber = "El número de registro es obligatorio";
        }
        if (!this.state.registryDate) {
            errors.registryDate = "La fecha de emisión del registro es obligatoria";
        }

        // Vehicle validation
        if (!this.state.vehicleBrand.trim()) {
            errors.vehicleBrand = "La marca del vehículo es obligatoria";
        }
        if (!this.state.vehicleType) {
            errors.vehicleType = "El tipo de vehículo es obligatorio";
        }

        // Branch validation
        if (!this.state.branchId || this.state.branchId === 0) {
            errors.branchId = "Debe seleccionar una sucursal";
        }

        this.setState({ errors });
        return Object.keys(errors).length === 0;
    }

    addVehicle = () => {
        const newVehicle: Vehicle = {
            brand: "",
            model: "",
            type: "MOTORCICLE",
            year: "",
            capacidadVolumetrica: 0,
            image: ""
        };
        this.setState({
            vehicles: [...this.state.vehicles, newVehicle]
        });
    };

    removeVehicle = (index: number) => {
        const vehicles = [...this.state.vehicles];
        vehicles.splice(index, 1);
        this.setState({ vehicles });
    };

    updateVehicle = (index: number, field: keyof Vehicle, value: any) => {
        const vehicles = [...this.state.vehicles];
        vehicles[index] = { ...vehicles[index], [field]: value };
        this.setState({ vehicles });
    };

    render() {
        const { data, cancel, sendData, branches } = this.props;
        const isEdit = !!(data && data.id);

        return (
            <form
                onSubmit={e => {
                    e.preventDefault();
                    if (!this.validate()) {
                        return;
                    }

                    const formData: any = {
                        id: data && data.id,
                        user: {
                            id: data && data.user ? data.user.id : undefined,
                            name: this.state.userName,
                            email: this.state.userEmail,
                            ...(this.state.userPassword && { password: this.state.userPassword })
                        },
                        driver: {
                            id: data && data.id,
                            region: this.state.region,
                            registryNumber: this.state.registryNumber,
                            registryDate: this.state.registryDate,
                            phone: this.state.phone,
                            document: this.state.document,
                            type: this.state.type,
                            referenceId: Number(this.state.referenceId) || 0,
                            notifyLocation: this.state.notifyLocation,
                            notifyLogout: this.state.notifyLogout,
                            recordLocation: this.state.recordLocation,
                            outsourced: this.state.outsourced,
                            fixedPayment: Number(this.state.fixedPayment),
                            paymentPerKm: Number(this.state.paymentPerKm),
                            manager: this.state.manager,
                            markAttendance: this.state.markAttendance
                        },
                        // vehicle: {
                        //     brand: this.state.vehicleBrand,
                        //     model: this.state.vehicleModel,
                        //     type: this.state.vehicleType,
                        //     year: this.state.vehicleYear,
                        //     capacidadVolumetrica: Number(this.state.vehicleCapacidadVolumetrica),
                        //     image: ""
                        // },
                        vehicles: this.state.vehicles.length > 0 ? this.state.vehicles : undefined,
                        branch: this.state.branchId
                    };

                    sendData({ formData } as any);
                }}
            >
                <Grid container spacing={16}>
                    {/* User Section */}
                    <Grid item xs={12}>
                        <Typography style={{ marginTop: 16, marginBottom: 8 }}>
                            Datos del usuario
                        </Typography>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            required
                            value={this.state.userName}
                            onChange={(e) => this.setState({ userName: e.target.value })}
                            error={!!this.state.errors.userName}
                            helperText={this.state.errors.userName}
                            margin="normal"
                            label="Nombre"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            required
                            type="email"
                            value={this.state.userEmail}
                            onChange={(e) => this.setState({ userEmail: e.target.value })}
                            error={!!this.state.errors.userEmail}
                            helperText={this.state.errors.userEmail}
                            margin="normal"
                            label="Correo electrónico"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            required={!isEdit}
                            type="password"
                            value={this.state.userPassword}
                            onChange={(e) => this.setState({ userPassword: e.target.value })}
                            error={!!this.state.errors.userPassword}
                            helperText={this.state.errors.userPassword || (isEdit ? "Deja vacío para mantener la contraseña actual" : "Usa un password complejo (mínimo 6 caracteres)")}
                            margin="normal"
                            label={isEdit ? "Nueva Contraseña (opcional)" : "Contraseña"}
                        />
                    </Grid>

                    {/* Driver Section */}
                    <Grid item xs={12}>
                        <Typography  style={{ marginTop: 16, marginBottom: 8 }}>
                            Datos del conductor
                        </Typography>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            required
                            value={this.state.region}
                            onChange={(e) => this.setState({ region: e.target.value })}
                            error={!!this.state.errors.region}
                            helperText={this.state.errors.region}
                            margin="normal"
                            label="Región preferida"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            required
                            value={this.state.registryNumber}
                            onChange={(e) => this.setState({ registryNumber: e.target.value })}
                            error={!!this.state.errors.registryNumber}
                            helperText={this.state.errors.registryNumber}
                            margin="normal"
                            label="Número de registro"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            required
                            type="date"
                            value={this.state.registryDate}
                            onChange={(e) => this.setState({ registryDate: e.target.value })}
                            error={!!this.state.errors.registryDate}
                            helperText={this.state.errors.registryDate}
                            margin="normal"
                            label="Fecha emisión registro"
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            value={this.state.phone}
                            onChange={(e) => this.setState({ phone: e.target.value })}
                            margin="normal"
                            label="Teléfono"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            value={this.state.document}
                            onChange={(e) => this.setState({ document: e.target.value })}
                            margin="normal"
                            label="Cédula de identidad o documento"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            select
                            fullWidth
                            required
                            value={this.state.type}
                            onChange={(e) => this.setState({ type: e.target.value })}
                            margin="normal"
                            label="Tipo de orden preferida"
                        >
                            <MenuItem value="REMISION">Remisiones/Repartos</MenuItem>
                            <MenuItem value="OTHER">Otro</MenuItem>
                        </TextField>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            type="number"
                            value={this.state.referenceId}
                            onChange={(e) => this.setState({ referenceId: Number(e.target.value) })}
                            margin="normal"
                            label="Referencia (ping)"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            select
                            fullWidth
                            required
                            value={this.state.branchId}
                            onChange={(e) => this.setState({ branchId: Number(e.target.value) })}
                            error={!!this.state.errors.branchId}
                            helperText={this.state.errors.branchId}
                            margin="normal"
                            label="Sucursal"
                        >
                            <MenuItem value={0}>Seleccione una sucursal</MenuItem>
                            {branches.map(branch => (
                                <MenuItem key={branch.id} value={branch.id}>{branch.name}</MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.notifyLocation}
                                    onChange={(e) => this.setState({ notifyLocation: e.target.checked })}
                                    color="primary"
                                />
                            }
                            label="Notificar ubicación"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.notifyLogout}
                                    onChange={(e) => this.setState({ notifyLogout: e.target.checked })}
                                    color="primary"
                                />
                            }
                            label="Ubicación activa al cerrar sesión"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.recordLocation}
                                    onChange={(e) => this.setState({ recordLocation: e.target.checked })}
                                    color="primary"
                                />
                            }
                            label="Registrar historial"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.outsourced}
                                    onChange={(e) => this.setState({ outsourced: e.target.checked })}
                                    color="primary"
                                />
                            }
                            label="Conductor tercerizado"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            type="number"
                            value={this.state.fixedPayment}
                            onChange={(e) => this.setState({ fixedPayment: Number(e.target.value) })}
                            margin="normal"
                            label="Pago fijo"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            type="number"
                            value={this.state.paymentPerKm}
                            onChange={(e) => this.setState({ paymentPerKm: Number(e.target.value) })}
                            margin="normal"
                            label="Pago por km"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.manager || false}
                                    onChange={(e) => this.setState({ manager: e.target.checked })}
                                    color="primary"
                                />
                            }
                            label="Es encargado"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.markAttendance || false}
                                    onChange={(e) => this.setState({ markAttendance: e.target.checked })}
                                    color="primary"
                                />
                            }
                            label="Marca asistencia?"
                        />
                    </Grid>

                    {/* Vehicle Section */}
                    {/* <Grid item xs={12}>
                        <Typography  style={{ marginTop: 16, marginBottom: 8 }}>
                            Datos del vehículo
                        </Typography>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            required
                            value={this.state.vehicleBrand}
                            onChange={(e) => this.setState({ vehicleBrand: e.target.value })}
                            error={!!this.state.errors.vehicleBrand}
                            helperText={this.state.errors.vehicleBrand}
                            margin="normal"
                            label="Marca"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            value={this.state.vehicleModel}
                            onChange={(e) => this.setState({ vehicleModel: e.target.value })}
                            margin="normal"
                            label="Modelo"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            select
                            fullWidth
                            required
                            value={this.state.vehicleType}
                            onChange={(e) => this.setState({ vehicleType: e.target.value })}
                            error={!!this.state.errors.vehicleType}
                            helperText={this.state.errors.vehicleType}
                            margin="normal"
                            label="Tipo de vehículo"
                        >
                            <MenuItem value="MOTORCYCLE">Motocicleta</MenuItem>
                            <MenuItem value="CAR">Automóvil</MenuItem>
                        </TextField>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            value={this.state.vehicleYear}
                            onChange={(e) => this.setState({ vehicleYear: e.target.value })}
                            margin="normal"
                            label="Año"
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            type="number"
                            value={this.state.vehicleCapacidadVolumetrica}
                            onChange={(e) => this.setState({ vehicleCapacidadVolumetrica: Number(e.target.value) })}
                            margin="normal"
                            label="Capacidad volumétrica (m³)"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            type="number"
                            value={this.state.vehicleFixedPayment}
                            onChange={(e) => this.setState({ vehicleFixedPayment: Number(e.target.value) })}
                            margin="normal"
                            label="Pago fijo"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            type="number"
                            value={this.state.vehiclePaymentPerKm}
                            onChange={(e) => this.setState({ vehiclePaymentPerKm: Number(e.target.value) })}
                            margin="normal"
                            label="Pago por km"
                        />
                    </Grid>
                    *}

                    {/* Additional Vehicles Section */}
                    <Grid item xs={12}>
                        <Typography  style={{ marginTop: 24, marginBottom: 8 }}>
                            Agregar vehículo
                            <IconButton
                                color="primary"
                                onClick={this.addVehicle}
                                style={{ marginLeft: 8 }}
                            >
                                <AddIcon />
                            </IconButton>
                        </Typography>
                    </Grid>

                    {this.state.vehicles.map((vehicle, index) => (
                        <Grid item xs={12} key={index}>
                            <Paper style={{ padding: 16, marginBottom: 16, position: 'relative' }}>
                                {/* <IconButton
                                    onClick={() => this.removeVehicle(index)}
                                    style={{ position: 'absolute', top: 8, right: 8 }}
                                >
                                    <DeleteIcon />
                                </IconButton> */}
                                <Typography  style={{ marginBottom: 16 }}>
                                    Vehículo #{index + 1}
                                </Typography>
                                <Grid container spacing={16}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            required
                                            value={vehicle.brand}
                                            onChange={(e) => this.updateVehicle(index, 'brand', e.target.value)}
                                            margin="normal"
                                            label="Marca"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            value={vehicle.model}
                                            onChange={(e) => this.updateVehicle(index, 'model', e.target.value)}
                                            margin="normal"
                                            label="Modelo"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            select
                                            fullWidth
                                            required
                                            value={vehicle.type}
                                            onChange={(e) => this.updateVehicle(index, 'type', e.target.value)}
                                            margin="normal"
                                            label="Tipo de vehículo"
                                        >
                                            <MenuItem value="MOTORCYCLE">Motocicleta</MenuItem>
                                            <MenuItem value="CAR">Automóvil</MenuItem>
                                        </TextField>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            value={vehicle.year}
                                            onChange={(e) => this.updateVehicle(index, 'year', e.target.value)}
                                            margin="normal"
                                            label="Año"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            type="number"
                                            value={vehicle.capacidadVolumetrica}
                                            onChange={(e) => this.updateVehicle(index, 'capacidadVolumetrica', Number(e.target.value))}
                                            margin="normal"
                                            label="Capacidad volumétrica (m³)"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            type="number"
                                            value={vehicle.fixedPayment || 0}
                                            onChange={(e) => this.updateVehicle(index, 'fixedPayment', Number(e.target.value))}
                                            margin="normal"
                                            label="Pago fijo"
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            type="number"
                                            value={vehicle.paymentPerKm || 0}
                                            onChange={(e) => this.updateVehicle(index, 'paymentPerKm', Number(e.target.value))}
                                            margin="normal"
                                            label="Pago por km"
                                        />
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                    ))}

                    {/* Action Buttons */}
                    <Grid container justify="space-around" style={{ marginTop: 24 }}>
                        <Grid item>
                            <Button variant="contained" onClick={cancel}>
                                Cancelar
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" color="primary" type="submit">
                                Aceptar
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </form>
        );
    }
}

export default DriverForm;



// WEBPACK FOOTER //
// ./src/components/DriverForm.tsx